export default __webpack_public_path__ + "static/ay-support-content-system-audits-322c1c832112c7e13a3d709d1f530902.svg";